module.exports = __webpack_public_path__ + "img/my-photo.3d47a7e0.jpg";